<template>
  <div class="topWrapper">
    <div class="logo">
      <img src="../../../../static/images/loginBg.jpg" alt="" />
    </div>
    <div class="personalBox">
      <div class="buttons" @click="statusChange">
        <!--                <i class="el-icon-s-fold" v-if="retractable"></i>-->
        <!--                <i class="el-icon-s-unfold" v-else></i>-->
      </div>
      <div class="logout">
        <i class="el-icon-user"></i>
        <span class="userName">Hi,{{ userName }}</span>
        <span class="logoutButton" @click="logout"
          >退出<i class="el-icon-switch-button"></i
        ></span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Top",
  data() {
    return {
      retractable: false,
      userName: "",
    };
  },
  methods: {
    statusChange() {
      this.retractable = !this.retractable;
    },
    logout() {
      window.sessionStorage.clear();
      this.$router.push({ name: "Login" });
    },
  },
  computed: {
    loginData() {
      if (window.sessionStorage.getItem("loginData")) {
        return JSON.parse(window.sessionStorage.getItem("loginData"));
      }
      return null;
    },
  },
  mounted() {
    if (this.loginData) {
      this.userName = this.loginData.nickname;
    }
  },
};
</script>

<style lang="scss" scoped>
.topWrapper {
  width: 100%;
  height: 50px;
  border-bottom: 1px solid #f7f6f9;
  display: flex;
  background: #fff;

  .logo {
    img {
      width: 220px;
      height: 50px;
    }
  }

  .personalBox {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0 20px 0 10px;
    width: calc(100% - 220px);
    font-size: 16px;

    .buttons {
      font-size: 20px;
    }

    .logout {
      .userName {
        margin: 0 10px 0 4px;
        padding-right: 10px;
        border-right: 1px solid #ddd;
      }

      .logoutButton {
        cursor: pointer;

        i {
          margin-left: 10px;
          color: #e64b29;
        }
      }

      i {
        font-weight: bold;
      }
    }
  }
}
</style>
